import React from 'react';
import { PageContext } from '@xingternal/pages-common';

export const usePageContext = () => {
  const context = React.useContext(PageContext);
  if (!context) {
    throw new Error('You need to use this with a PageContext');
  }
  return context;
};

export default usePageContext;
